import { render, staticRenderFns } from "./psyco_patients.vue?vue&type=template&id=1d2987ce&scoped=true"
import script from "./psyco_patients.vue?vue&type=script&lang=js"
export * from "./psyco_patients.vue?vue&type=script&lang=js"
import style0 from "./psyco_patients.vue?vue&type=style&index=0&id=1d2987ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d2987ce",
  null
  
)

export default component.exports